import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["swither-block", {checked: _ctx.modelValue}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !_ctx.modelValue)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "switcher" }, [
      _createElementVNode("div", { class: "switcher-round" })
    ], -1)),
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
  ], 2))
}